export const getNotificationMessagesSelector = ({ notifications }) => notifications.messages || [];
